import React from 'react';

const AboutPage = () => {
  return (
    <>
      {/* Hero Section */}
      <div className="relative px-6 text-center text-white heading--bg pt-36 pb-44" style={{ 
        paddingTop: '144px', 
        backgroundImage: 'linear-gradient(to right, rgba(0, 0, 0, 0.15) 0%, rgba(0, 0, 0, 0.03) 100%), url("https://static2.givesendgo.com/vue/headings/teal.jpg")',
        backgroundPosition: '50% 20%'
      }}>
        <h1 className="relative z-10 text-4xl md:text-5xl font-bold">About DonatePe</h1>
        <div className="shape__divider--bottom relative z-10">
          <svg data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 120" preserveAspectRatio="none">
            <path d="M0,0V46.29c47.79,22.2,103.59,32.17,158,28,70.36-5.37,136.33-33.31,206.8-37.5C438.64,32.43,512.34,53.67,583,72.05c69.27,18,138.3,24.88,209.4,13.08,36.15-6,69.85-17.84,104.45-29.34C989.49,25,1113-14.29,1200,52.47V0Z" opacity=".25" className="shape-fill"></path>
            <path d="M0,0V15.81C13,36.92,27.64,56.86,47.69,72.05,99.41,111.27,165,111,224.58,91.58c31.15-10.15,60.09-26.07,89.67-39.8,40.92-19,84.73-46,130.83-49.67,36.26-2.85,70.9,9.42,98.6,31.56,31.77,25.39,62.32,62,103.63,73,40.44,10.79,81.35-6.69,119.13-24.28s75.16-39,116.92-43.05c59.73-5.85,113.28,22.88,168.9,38.84,30.2,8.66,59,6.17,87.09-7.5,22.43-10.89,48-26.93,60.65-49.24V0Z" opacity=".5" className="shape-fill"></path>
            <path d="M0,0V5.63C149.93,59,314.09,71.32,475.83,42.57c43-7.64,84.23-20.12,127.61-26.46,59-8.63,112.48,12.24,165.56,35.4C827.93,77.22,886,95.24,951.2,90c86.53-7,172.46-45.71,248.8-84.81V0Z" className="shape-fill"></path>
          </svg>
        </div>
      </div>

      {/* About Section */}
      <section className="mx-auto max-w-7xl px-4 py-12">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
          <div className="flex flex-col justify-center">
            <h2 id="about__heading" className="text-3xl font-bold text-left mb-6">About DonatePe</h2>
            <p className="leading-loose text-left lg:max-w-lg">
              In 2014, three siblings had an idea. What would it look like if we took the newly popular idea of crowdfunding, and stretched it beyond just funding help for people's material needs but also providing hope for people's spiritual needs? Out of those discussions, DonatePe was born. After over a year of development and setbacks, DonatePe was launched with a beta version in early 2015.
            </p>
          </div>
          <div className="about-image">
            <picture>
              <source srcSet="https://static2.givesendgo.com/vue/about/about_1.webp" type="image/webp" />
              <source srcSet="https://static2.givesendgo.com/vue/about/about_1.jpg" type="image/jpeg" />
              <source srcSet="https://static2.givesendgo.com/vue/about/about_1.png" type="image/png" />
              <img 
                className="rounded-lg w-full h-auto object-cover"
                alt="Joyful young girl playing in a sunlit field of tall grass" 
                src="https://static2.givesendgo.com/vue/about/about_1.jpg"
              />
            </picture>
          </div>
          
          <div>
            <picture>
              <source srcSet="https://static2.givesendgo.com/vue/about/about_2.webp" type="image/webp" />
              <source srcSet="https://static2.givesendgo.com/vue/about/about_2.jpg" type="image/jpeg" />
              <source srcSet="https://static2.givesendgo.com/vue/about/about_2.png" type="image/png" />
              <img 
                className="rounded-lg w-full h-auto object-cover"
                alt="Happy father embracing his son and daughter outside a modern building with reflection of their hug" 
                src="https://static2.givesendgo.com/vue/about/about_2.jpg"
              />
            </picture>
          </div>
          
          <div className="about-image">
            <picture>
              <source srcSet="https://static2.givesendgo.com/vue/about/about_3.webp" type="image/webp" />
              <source srcSet="https://static2.givesendgo.com/vue/about/about_3.jpg" type="image/jpeg" />
              <source srcSet="https://static2.givesendgo.com/vue/about/about_3.png" type="image/png" />
              <img 
                className="rounded-lg w-full h-auto object-cover"
                alt="Volunteers serving food to community members at a local charity event" 
                src="https://static2.givesendgo.com/vue/about/about_3.jpg"
              />
            </picture>
          </div>
        </div>

        <div className="flex flex-col mt-10 leading-loose text-left">
          <p className="mb-4">
            We had meetings daily and would talk about and pray for DonatePe and the direction we were headed.
          </p>
          <p className="mb-4">
            We had a public launch party in October 2015, once we felt the site was ready to be put out into the world. We saw steady growth as we worked tirelessly behind the scenes with fixes and changes, making the website work more efficiently, while learning the lessons needed to grow a crowdfunding platform.
          </p>
          
          <div className="my-6 lg:hidden">
            <picture>
              <source srcSet="https://static2.givesendgo.com/vue/about/about_2.webp" type="image/webp" />
              <source srcSet="https://static2.givesendgo.com/vue/about/about_2.jpg" type="image/jpeg" />
              <source srcSet="https://static2.givesendgo.com/vue/about/about_2.png" type="image/png" />
              <img 
                className="rounded-lg w-full h-auto object-cover"
                alt="Volunteers serving food to community members at a local charity event" 
                src="https://static2.givesendgo.com/vue/about/about_2.jpg"
              />
            </picture>
          </div>
          
          <p>
            Year after year we kept running the race in obedience and with persistence waiting for the day DonatePe.com would take off. Little did we know God was just preparing us for the plans he had for us. At the end of the summer of 2020 during the middle of a pandemic, we watched as DonatePe was thrust into the political spotlight for allowing a campaign that mainstream media had shut down and was censoring. Unbeknownst to us we had stepped onto a battlefield and had to take a stand. After much prayer, discussion, and counsel a decision was made. DonatePe was created for such a time as this. Not to take one side or another politically, but in the middle of a divided political culture, we were to be focused on the very reason we started DonatePe, to share the Hope of Jesus through crowdfunding to everyone who comes to our platform. That continues to be our focus as we stand for freedom.
          </p>
        </div>
      </section>

      {/* How We're Different Section */}
      <section className="flex flex-col justify-center px-6 pt-0 text-center py-12">
        <h3 className="text-3xl font-bold mb-4">DonatePe: Giving you the freedom to fundraise</h3>
        <p className="text-lg text-gray-600 mb-8">Here is how we are different than other crowdfunding platforms.</p>
        
        <div className="flex flex-wrap justify-center mx-auto mt-8 max-w-7xl md:mt-12 xl:mt-24 icon-container gap-8">
          <div className="icon__box flex flex-col items-center max-w-xs p-6">
            <div className="flex items-center justify-center w-24 h-24 bg-gray-200 rounded-full mb-6">
              <img className="w-12 h-12" src="https://static2.givesendgo.com/vue/whyus/money.svg" alt="Money Icon" />
            </div>
            <p className="leading-loose">
              We are FREE. We charge no money to use our platform. We believe you should be able to keep all the money you raise. GSG is powered by voluntary donations from Givers and Goers. Other crowdfunding sites take between 5%-10% of the money raised by a campaign.
            </p>
          </div>
          
          <div className="icon__box flex flex-col items-center max-w-xs p-6">
            <div className="flex items-center justify-center w-24 h-24 bg-gray-200 rounded-full mb-6">
              <img className="w-12 h-12" src="https://static2.givesendgo.com/vue/whyus/star.svg" alt="Star Icon" />
            </div>
            <p className="leading-loose">
              Each month, GiveSendGo designates some of our operation expenses to 'Give Back' to active campaigns on our site. We're the only crowdfunding site that believes so much in what you're doing that we put our money where our mouth is. We love being Givers!
            </p>
          </div>
          
          <div className="icon__box flex flex-col items-center max-w-xs p-6">
            <div className="flex items-center justify-center w-24 h-24 bg-gray-200 rounded-full mb-6">
              <img className="w-12 h-12" src="https://static2.givesendgo.com/vue/whyus/christian.svg" alt="Christian Icon" />
            </div>
            <p className="leading-loose">
              The most valuable currency is God's love. Only God can meet the deepest needs of each heart. That's why we're grateful to have individuals and organizations dedicated to praying over our campaigns. We pray for eternal results because those are ultimately the only outcomes that matter. The God we serve will ALWAYS be bigger than money.
            </p>
          </div>
          
          <div className="icon__box flex flex-col items-center max-w-xs p-6">
            <div className="flex items-center justify-center w-24 h-24 bg-gray-200 rounded-full mb-6">
              <img className="w-12 h-12" src="https://static2.givesendgo.com/vue/whyus/world.svg" alt="World Icon" />
            </div>
            <p className="leading-loose">
              On GSG, Goers can choose to raise funds for short or long-term campaigns. DonatePe allows Goers to set up their campaign to receive monthly recurring donations from their Givers. Traveling across the country and world to share God's love just got easier.
            </p>
          </div>
          
          <div className="icon__box flex flex-col items-center max-w-xs p-6">
            <div className="flex items-center justify-center w-24 h-24 bg-gray-200 rounded-full mb-6">
              <img className="w-12 h-12" src="https://static2.givesendgo.com/vue/whyus/share.svg" alt="Share Icon" />
            </div>
            <p className="leading-loose">
              Outside the obvious funding for mission trips, GSG also can be used to raise funds for medical expenses, business ventures, personal needs, churches, nonprofits, ministries or any "God Adventure" you embark on. Whether you're a Giver, Sender or Goer, you can be used by God to be a difference maker!
            </p>
          </div>
        </div>
      </section>

      {/* Freedom Section */}
      <section className="relative flex flex-col items-center justify-center px-6 text-white freedom__section bg-slate-100 py-16 md:py-24" style={{
        backgroundImage: "url('https://static2.givesendgo.com/images/fundraising-bg.jpg')",
        backgroundSize: 'cover',
        backgroundPosition: 'center'
      }}>
        <div className="relative z-10 w-full max-w-7xl">
          <h1 id="freedom__heading" className="flex flex-col text-center mb-8">
            <span className="font-light text-3xl md:text-4xl">The Leader in</span>
            <span className="font-bold text-4xl md:text-5xl mt-2">Online Fundraising</span>
          </h1>
          
          <div className="w-40 mx-auto mt-10 bg-white divider h-1"></div>
          
          <div className="grid lg:grid-cols-3 md:grid-cols-2 sm:grid-cols-1 gap-12 mt-14">
            <div className="flex flex-col items-center max-w-xs space-y-2 text-center">
              <img className="w-24 h-24" src="https://static2.givesendgo.com/vue/freedomfundraising/worldwide-leader.png" alt="Worldwide Leader" />
              <h5 className="mt-4 text-xl font-semibold">Worldwide Leader</h5>
              <p>DonatePe is trusted around the world for its simple, reliable fundraising platform.</p>
            </div>
            
            <div className="flex flex-col items-center max-w-xs space-y-2 text-center">
              <img className="w-24 h-24" src="https://static2.givesendgo.com/vue/freedomfundraising/simple-setup.png" alt="Simple Setup" />
              <h5 className="mt-4 text-xl font-semibold">Simple Setup</h5>
              <p>Personalize, share and start collecting money in just minutes.</p>
            </div>
            
            <div className="flex flex-col items-center max-w-xs space-y-2 text-center">
              <img className="w-24 h-24" src="https://static2.givesendgo.com/vue/freedomfundraising/zero-fee.png" alt="Zero Fee" />
              <h5 className="mt-4 text-xl font-semibold">0% Platform Fee</h5>
              <p>Keep more of the money you raised. We don't charge a platform fee, watching you raise money makes us happy.</p>
            </div>
            
            <div className="flex flex-col items-center max-w-xs space-y-2 text-center">
              <img className="w-24 h-24" src="https://static2.givesendgo.com/vue/freedomfundraising/share-hope.png" alt="Share Hope" />
              <h5 className="mt-4 text-xl font-semibold">Share Hope</h5>
              <p>Raise money to share hope. Money is temporary Jesus is eternal. Give both and watch the world be changed.</p>
            </div>
            
            <div className="flex flex-col items-center max-w-xs space-y-2 text-center">
              <img className="w-24 h-24" src="https://static2.givesendgo.com/vue/freedomfundraising/easy-social-reach.png" alt="Easy Social Reach" />
              <h5 className="mt-4 text-xl font-semibold">Easy Social Reach</h5>
              <p>Share across multiple social platforms and mobile devices with just a couple clicks of a button.</p>
            </div>
            
            <div className="flex flex-col items-center max-w-xs space-y-2 text-center">
              <img className="w-24 h-24" src="https://static2.givesendgo.com/vue/freedomfundraising/customer-service.png" alt="Customer Service" />
              <h5 className="mt-4 text-xl font-semibold">A+ Customer Service</h5>
              <p>Real people writing real responses. We are standing by, waiting to help.</p>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default AboutPage;